module.exports = __webpack_public_path__ + "static/media/selfie-doodle.52d22bc0.png";